import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { groupService } from '../../services/api';
import ResponsiveTable from '../common/ResponsiveTable';
import StatusPill from '../shared/StatusPill';

const GroupUsersModal = ({ open, onClose, groupId }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    if (open && groupId) {
      fetchGroupUsers();
    }
  }, [open, groupId]);

  const fetchGroupUsers = async () => {
    try {
      setLoading(true);
      const response = await groupService.getGroupUsers(groupId);
      if (response.data.success) {
        setUsers(response.data.users);
        setGroupName(response.data.groupName);
      }
    } catch (error) {
      console.error('Error fetching group users:', error);
    } finally {
      setLoading(false);
    }
  };
  const columns=[
              { id: 'name', label: 'Name' },
              { id: 'email', label: 'Email' },
              { id: 'audience_type', label: 'Audience Type' },
              { id: 'active', label: 'Status' },
            ];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              Group Members - {groupName}
            </Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
      </DialogTitle>
      <DialogContent dividers>
        <ResponsiveTable
          columns={columns}
          rows={users}
          loading={loading}
          emptyTitle="No learner records found"
          renderCell={(column, row) => {
            const value = column.format ? column.format(row) : row[column.id];

            if (column.id === 'name') {
              return `${row.first_name} ${row.last_name}`;
            }

            if (column.id === 'audience_type') {
              return row.audience_type === 1
                ? 'Internal'
                : row.audience_type === 2
                ? 'External'
                : '-';
            }

            if (column.id === 'active') {              
              return <StatusPill status={ row.active ? 'Active' : 'Inactive'} />;
            }

            return value;
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupUsersModal;